import { Injectable } from '@angular/core';

/** Keeps a single audio playing at a time: the student's recording and the pronunciation speech. */
@Injectable({ providedIn: 'root' })
export class ExclusiveAudioPlaybackService {
  private currentMedia?: HTMLMediaElement;

  /** Pauses whatever was playing before `media`, which is about to play. */
  claim(media: HTMLMediaElement): void {
    if (this.currentMedia && this.currentMedia !== media) this.currentMedia.pause();
    this.currentMedia = media;
  }

  /** Stops tracking an element that will not play again. */
  release(media: HTMLMediaElement): void {
    if (this.currentMedia === media) this.currentMedia = undefined;
  }
}
